import { Button } from "@/shared/ui/button.tsx"
import { AlertOctagon, MoveLeft } from "lucide-react"
import { Link } from "react-router-dom"

const ErrorPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[100dvh] px-4 text-center bg-background">
      <div className="space-y-6 max-w-md mx-auto">
        <div className="space-y-2">
          <div className="flex justify-center">
            <div className="rounded-full bg-red-100 p-4 text-red-600">
              <AlertOctagon className="h-12 w-12" />
            </div>
          </div>
          <h1 className="text-2xl font-bold tracking-tighter sm:text-3xl">Something went wrong!</h1>
          <p className="text-muted-foreground">
            We're sorry, but we encountered an unexpected error. Our team has been notified and is working to fix the
            issue.
          </p>
        </div>
        <div className="flex justify-center">
          <Button asChild>
            <Link to="/">
              <MoveLeft className="mr-2 h-4 w-4" />
              Back to home
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ErrorPage
